import * as React from 'react'
import {ACTION_TYPES} from '../../constants/articleTypesConstants'

export const searchState = {
  redirectSearch: false,
  searchTerm: '',
  suggestions: [],
  contactOption: {},
}
interface IActionPayload {
  payload: any
  type: string
  clearSearchTerm?: boolean
}
interface IContextProps {
  dispatchToSearch: (obj: IActionPayload) => void
  searchData: IState
}
interface IContactOption {
  firstName: string
  lastName: string
  id: string
  clearable: Boolean
}

interface IState {
  redirectSearch: boolean
  searchTerm: string
  suggestions: any
  contactOption?: IContactOption
}
export interface IFilterState extends IState {
  allFilters: Record<string, string>
  selectedFilters: Record<string, any>
}

export const SearchContext = React.createContext({} as IContextProps)

export const searchReducer = (state: IState, action: IActionPayload) => {
  switch (action.type) {
    case ACTION_TYPES.SET_SEARCH_TERM: {
      return {
        ...state,
        searchTerm: action.payload,
      }
    }
    case ACTION_TYPES.SET_SEARCH_SUGGESTIONS: {
      return {
        ...state,
        suggestions: state.searchTerm.length > 0 ? action.payload : [],
      }
    }
    case ACTION_TYPES.SET_REDIRECT: {
      return {
        ...state,
        redirectSearch: action.payload,
      }
    }
    case ACTION_TYPES.SET_SEARCH_HISTORY_SUGGESTIONS: {
      return {
        ...state,
        suggestions: action.payload,
      }
    }
    case ACTION_TYPES.SET_CONTACT_OPTION: {
      return {
        ...state,
        contactOption: action.payload,
        searchTerm: action.clearSearchTerm ? '' : state.searchTerm,
      }
    }
    default:
      return state
  }
}

export const searchFilterReducer = (
  state: IFilterState,
  action: IActionPayload
) => {
  switch (action.type) {
    case ACTION_TYPES.SET_SEARCH_FILTERS: {
      return {
        ...state,
        allFilters: action.payload,
      }
    }
    case ACTION_TYPES.SET_SEARCH_SELECTED_FILTER: {
      return {
        ...state,
        selectedFilters: {
          ...state.selectedFilters,
          ...action.payload,
        },
      }
    }
    case ACTION_TYPES.SET_SELECTED_FILTERS: {
      return {
        ...state,
        selectedFilters: action.payload,
      }
    }
    case ACTION_TYPES.TOGGLE_WIKI_TAG: {
      const tags: string[] = state.selectedFilters.tags || []
      const exists = tags.includes(action.payload)
      return {
        ...state,
        selectedFilters: {
          ...state.selectedFilters,
          tags: exists
            ? tags.filter((t: string) => t !== action.payload)
            : [...tags, action.payload as string[]],
        },
      }
    }
    default:
      return state
  }
}

export function toUnixTimestamp(dateStr: string) {
  const date = new Date(dateStr)
  return Math.floor(date.getTime() / 1000)
}
